import Immutable from 'immutable';
import * as types from '../actionTypes/claimDocumentsActionTypes';
import * as irSearchTypes from '../actionTypes/irSearchActionTypes';
import { createReducer } from '../utils';

const initialStateValue = {
  status: '',
  favoriteEmail: {
    status: 'loading',
    email: '',
  },
  popup: {
    name: null,
    show: false,
    data: {},
  },
  docketParts: {
    step: 0,
    purchased: 0,
    partsToPurchase: 0,
    totalCost: 0,
    parts: 0,
    percentage: 0,
    status: 'loading',
    errors: null,
    alreadyPurchased: false,
  },
  selectedClaim: {
    status: null,
    seqNum: null,
    claimNum: null,
    courtCode: null,
    caseNumber: null,
    documents: {},
    binder: {
      // documents: [],
    },
  },
  documentsList: [],
  redact: {
    showFlash: false,
    seqNum: null,
    showPopup: false,
  },
  entries: {
    // empty | loading | error
    status: '',
    data: [],
  },
  receipt: {},
  header: {
    status: '',
  },
};

const initialState = Immutable.fromJS(initialStateValue);

export default createReducer(initialState, {
  [types.DOCKETS_POPUP]: (state, action) => {
    const { popup } = action;
    return state.mergeDeep({ popup });
  },
  [types.DOCKETS_FAVORITE_EMAIL]: (state, action) => {
    const { favoriteEmail } = action;
    return state.mergeDeep({ favoriteEmail });
  },
  [types.UPDATE_CLAIMS_PARTS]: (state, action) => {
    const { claimsParts } = action;
    return state.mergeDeep({ claimsParts });
  },
  [types.RESET_CLAIMS_PARTS]: state => {
    const { claimsParts } = initialStateValue;
    return state.merge({ claimsParts });
  },
  [types.UPDATE_DOCKET_HEADER]: (state, action) => {
    const { docketHeader } = action;
    return state.mergeDeep({ docketHeader });
  },
  [irSearchTypes.REQUEST_DOCKET_PARTS]: (state, action) => {
    const step = action.step || 1;
    const pdfZip = { status: 'loading', step };
    return initialState.mergeDeep({ pdfZip });
  },
  [irSearchTypes.RECEIVE_DOCKET_PARTS]: (state, action) => {
    const pdfZip = { ...action.data, isLoading: false };
    return state.mergeDeep({ pdfZip });
  },
  [types.UPDATE_REDACT]: (state, action) => {
    const { redact } = action;
    return state.mergeDeep({ redact });
  },
  [types.FETCH_CLAIM_DOCUMENTS.REQUEST]: (state, { selectedClaim }) =>
    state.set('selectedClaim', initialState.get('selectedClaim').merge(selectedClaim)),

  [types.FETCH_CLAIM_DOCUMENTS.SUCCESS]: (state, { selectedClaim }) => {
    const { court_code, case_number, claimNum, seqNum, binder } = selectedClaim;
    return state
      .mergeDeep({ selectedClaim })
      .setIn(['documentsMap', court_code, case_number, claimNum, seqNum], Immutable.fromJS(binder.documents))
      .setIn(['entries', 'data'], state.getIn(['entries', 'data']).push(Immutable.fromJS(selectedClaim)));
  },
  [types.FETCH_CLAIM_DOCUMENTS.ERROR]: state => {
    return state.setIn(['selectedClaim', 'status'], 'done');
  },
  [types.BUY_PDF_DOCUMENT.REQUEST]: (state, { number }) => {
    const documentIndex = state
      .getIn(['selectedClaim', 'binder', 'documents'])
      .findIndex(doc => doc.get('number') === number);
    return state
      .setIn(['selectedClaim', 'documentIndex'], documentIndex)
      .setIn(['selectedClaim', 'binder', 'documents', documentIndex, 'status'], 'loading');
  },
  [types.BUY_PDF_DOCUMENT.ERROR]: state => {
    return state.setIn(
      ['selectedClaim', 'binder', 'documents', state.getIn(['selectedClaim', 'documentIndex']), 'status'],
      'done'
    );
  },
  [types.BUY_PDF_DOCUMENT.SUCCESS]: (state, { document }) => {
    const { court_code, case_number, claimNum, seqNum, documentIndex } = state.get('selectedClaim').toJS();
    const doc = Immutable.fromJS({ ...document, status: 'done' });
    return state
      .mergeIn(['selectedClaim', 'binder', 'documents', documentIndex], doc)
      .mergeIn(['documentsMap', court_code, case_number, claimNum, seqNum, documentIndex], doc);
  },
  [types.ORDER_PDF_DOCUMENT.REQUEST]: (state, { number }) => {
    const documentIndex = state
      .getIn(['selectedClaim', 'binder', 'documents'])
      .findIndex(doc => doc.get('number') === number);
    return state
      .setIn(['selectedClaim', 'documentIndex'], documentIndex)
      .setIn(['selectedClaim', 'binder', 'documents', documentIndex, 'status'], 'loading');
  },
  [types.ORDER_PDF_DOCUMENT.SUCCESS]: (state, { document }) => {
    const { court_code, case_number, claimNum, seqNum, documentIndex } = state.get('selectedClaim').toJS();
    const doc = Immutable.fromJS({ ...document, status: 'done' });
    return state
      .mergeIn(['selectedClaim', 'binder', 'documents', documentIndex], doc)
      .mergeIn(['documentsMap', court_code, case_number, claimNum, seqNum, documentIndex], doc);
  },
  /* [types.UPDATE_CLAIM_DOCUMENT]: (state, { selectedClaim, document }) => {
    const { court_code, case_number, claimNum, seqNum } = state.get('selectedClaim').toJS();
     const documentIndex = state
      .getIn(['selectedClaim', 'binder', 'documents'])
      .findIndex(doc => doc.get('number') === document.number);
    const updatedClaim = state.get('selectedClaim').setIn(['binder', 'documents', documentIndex], document);
    return state
      .setIn(['selectedClaim', 'binder', 'documents', document.number], document)
      .setIn(['documentsMap', court_code, case_number, claimNum, seqNum, document.number], document);
  }, */
  [types.UPDATE_SELECTED_CLAIM]: (state, { selectedClaim }) =>
    state.set('selectedClaim', Immutable.fromJS(selectedClaim)),
  [types.UPDATE_CLAIMS]: (state, action) => {
    // note we don't want mergeDeep here because it will "merge" any new array data, instead of replacing them
    return state.merge({ ...action });
  },
  SERVICE_ERROR: (state, action) => state.mergeDeep({ data_ready: true, error: action.errors }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/claimDocumentsReducer.js